<template>
  <div class="product-form-container">
    <!-- 全局加载遮罩层 -->
    <div class="loading-mask" v-if="loading">
      <div class="loading-spinner"></div>
    </div>
    <!-- 表单主体 -->
    <div class="form-wrapper" style="position: relative">
      <button
        class="btn publish-btn"
        style="position: absolute; right: 0"
        @click="Drafts"
      >
        草稿箱
      </button>
      <h1 class="panel-title">样衣发布</h1>
      <!-- 左侧表单区域 -->
      <div class="form-left">
        <!-- 样衣编号 -->
        <div class="form-item single-item">
          <label>样衣编号:</label>
          <input
            style="width: 150px"
            type="text"
            v-model="formData.productCode"
            placeholder="请输入样衣编号"
          />
          <label>类别:</label>
          <el-select
            v-model="formData.categoryId"
            placeholder="请选择类别"
            multiple
            collapse-tags
            clearable
            style="padding: 12px"
            :style="{ borderBottom: 'none' }"
          >
            <el-option
              v-for="option in leilist"
              :key="option.id"
              :label="option.name"
              :value="option.id"
            />
          </el-select>
        </div>
        <!-- 面料信息分组 -->
        <div class="fabric-group">
          <div class="group-title">面料信息：</div>
          <div class="form-item single-item">
            <label>品名/编号:</label>
            <el-select
              filterable
              v-model="formData.productpm"
              placeholder="请选择品名编号"
              @change="watchs(formData.productpm)"
              style="padding: 12px"
              :style="{ borderBottom: 'none' }"
            >
              <el-option
                v-for="option in lists"
                :key="option.id"
                :label="option.name"
                :value="option.name"
              />
            </el-select>
          </div>
          <!-- 两行两列布局：幅宽/克重、成份/类别 -->
          <div class="form-row">
            <div class="form-item">
              <label>幅宽:</label>
              <input disabled type="text" v-model="formData.width" />
            </div>
            <div class="form-item">
              <label>克重:</label>
              <input disabled type="text" v-model="formData.weight" />
            </div>
          </div>
          <div class="form-row">
            <div class="form-item">
              <label>成份:</label>
              <input disabled type="text" v-model="formData.composition" />
            </div>
            <div class="form-item" style="margin-left: 12px">
              <label>面料类别:</label>
              <el-tooltip :content="formData.texts" placement="top">
                <input disabled type="text" v-model="formData.texts" />
              </el-tooltip>
            </div>
          </div>
          <div class="form-row">
            <div class="form-item">
              <label>量化:</label>
              <input disabled type="text" v-model="formData.quantify" />
            </div>
            <div class="form-item">
              <label>备注:</label>
              <input disabled type="text" v-model="formData.remark" />
            </div>
          </div>
          <div class="form-row">
            <div class="form-item">
              <label>纱支:</label>
              <input disabled type="text" v-model="formData.yarnCount" />
            </div>
            <div class="form-item">
              <label>密度:</label>
              <input disabled type="text" v-model="formData.density" />
            </div>
          </div>
          <div class="form-row">
            <div class="form-item">
              <label>规格:</label>
              <input disabled type="text" v-model="formData.specification" />
            </div>
          </div>
        </div>
      </div>
      <!-- 右侧上传区域 -->
      <div class="form-right">
        <!-- 封面图上传 - 单个 -->
        <div class="upload-section">
          <h4>
            封面图<span style="font-size: 14px; color: #999"
              >（图片比例宽高3:4，单张图片不能超过1MB）</span
            >
          </h4>
          <div class="upload-boxes">
            <div
              class="upload-box"
              :key="`cover-1`"
              @click="handleUpload('cover', 1)"
            >
              <!-- 有本地File优先展示 -->
              <img
                v-if="uploadFiles[`cover-1`]"
                :src="getImagePreviewUrl(`cover-1`)"
                alt="封面图"
                class="uploaded-img"
              />
              <!-- 无File、但有Base64缓存 -->
              <template v-else-if="imgBase64[`cover-1`]">
                <img
                  :src="imgBase64[`cover-1`]"
                  alt="封面图"
                  class="uploaded-img"
                />
                <!-- 草稿已有图片不提示重传 -->
                <span v-if="!draftImages[`cover-1`]" class="reupload-tip"
                  >需重新上传</span
                >
              </template>
              <div
                v-if="uploadFiles[`cover-1`] || imgBase64[`cover-1`]"
                class="img-delete-btn"
                @click.stop="handleDeleteImage('cover', 1)"
              >
                ×
              </div>
              <span v-else>+</span>
            </div>
          </div>
        </div>
        <!-- 详情图上传 -->
        <div class="upload-section">
          <h4>
            详情图<span style="font-size: 14px; color: #999"
              >（详情图上限5张，单张图片不能超过1MB）</span
            >
          </h4>
          <div class="upload-container">
            <div
              v-if="getEffectiveFileCount('detail') < 5"
              class="upload-box add-btn"
              @click="handleUpload('detail', getNextUploadIndex('detail'))"
            >
              <span>+</span>
            </div>
            <!-- 增加ref用于绑定拖拽 -->
            <div ref="detailWrapRef" class="img-show-wrap" data-type="detail">
              <!-- 已重新上传（有本地File） -->
              <div
                class="upload-box img-item"
                v-for="(file, key) in getUploadedFiles('detail')"
                :key="key"
                :data-key="key"
              >
                <img
                  :src="getImagePreviewUrl(key)"
                  alt="详情图"
                  class="uploaded-img"
                />
                <div
                  class="img-delete-btn"
                  @click.stop="handleDeleteImage('detail', key.split('-')[1])"
                >
                  ×
                </div>
              </div>
              <!-- 仅缓存Base64，未重新上传 -->
              <div
                class="upload-box img-item"
                v-for="(base64, key) in getBase64Only('detail')"
                :key="key"
                :data-key="key"
                @click="handleUpload('detail', Number(key.split('-')[1]))"
              >
                <img :src="base64" alt="详情图" class="uploaded-img" />
                <!-- 草稿已有图片不提示重传 -->
                <span v-if="!draftImages[key]" class="reupload-tip"
                  >需重新上传</span
                >
                <div
                  class="img-delete-btn"
                  @click.stop="handleDeleteImage('detail', key.split('-')[1])"
                >
                  ×
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 电子色卡上传 -->
        <div class="upload-section">
          <h4>
            电子色卡<span style="font-size: 14px; color: #999"
              >（电子色卡图上限5张，单张图片不能超过1.3MB）</span
            >
          </h4>
          <div class="upload-container">
            <div
              v-if="getEffectiveFileCount('color') < 5"
              class="upload-box add-btn"
              @click="handleUpload('color', getNextUploadIndex('color'))"
            >
              <span>+</span>
            </div>
            <!-- 增加ref用于绑定拖拽 -->
            <div ref="colorWrapRef" class="img-show-wrap" data-type="color">
              <!-- 已重新上传（有本地File） -->
              <div
                class="upload-box img-item"
                v-for="(file, key) in getUploadedFiles('color')"
                :key="key"
                :data-key="key"
              >
                <img
                  :src="getImagePreviewUrl(key)"
                  alt="电子色卡"
                  class="uploaded-img"
                />
                <div
                  class="img-delete-btn"
                  @click.stop="handleDeleteImage('color', key.split('-')[1])"
                >
                  ×
                </div>
              </div>
              <!-- 仅缓存Base64，未重新上传 -->
              <div
                class="upload-box img-item"
                v-for="(base64, key) in getBase64Only('color')"
                :key="key"
                :data-key="key"
                @click="handleUpload('color', Number(key.split('-')[1]))"
              >
                <img :src="base64" alt="电子色卡" class="uploaded-img" />
                <!-- 草稿已有图片不提示重传 -->
                <span v-if="!draftImages[key]" class="reupload-tip"
                  >需重新上传</span
                >
                <div
                  class="img-delete-btn"
                  @click.stop="handleDeleteImage('color', key.split('-')[1])"
                >
                  ×
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 标题和正文输入区 -->
      <div class="textarea-section">
        <div class="textarea-item">
          <label>标题</label>
          <textarea
            v-model="formData.title"
            maxlength="45"
            placeholder="请输入标题,字数不能超过45个字"
          ></textarea>
        </div>
        <div class="textarea-item">
          <label>正文</label>
          <textarea
            v-model="formData.content"
            placeholder="请输入正文,字数不能超过150个字"
            maxlength="150"
            rows="6"
          ></textarea>
        </div>
      </div>
      <!-- 按钮组 -->
      <div class="btn-group">
        <button
          class="btn publish-btn"
          @click="handlePublish(0)"
          :disabled="loading"
        >
          发布
        </button>
        <button class="btn save-btn" @click="handlePublish(1)">暂存离开</button>
      </div>
      <!-- ==========全局隐藏file输入框 修复底部多出选择文件bug========== -->
      <div class="global-file-inputs" style="display: none">
        <input
          type="file"
          ref="coverFileInput1"
          class="file-input"
          accept="image/*"
          @change="(e) => handleFileChange('cover', 1, e)"
        />
        <!-- ==========详情图增加 multiple ========== -->
        <template v-for="idx in 5" :key="`detail-${idx}`">
          <input
            type="file"
            :ref="`detailFileInput${idx}`"
            class="file-input"
            accept="image/*"
            multiple
            @change="(e) => handleFileChange('detail', idx, e)"
          />
        </template>
        <!-- ==========电子色卡增加 multiple ========== -->
        <template v-for="idx in 5" :key="`color-${idx}`">
          <input
            type="file"
            :ref="`colorFileInput${idx}`"
            class="file-input"
            accept="image/*"
            multiple
            @change="(e) => handleFileChange('color', idx, e)"
          />
        </template>
      </div>
    </div>
  </div>
  <Drafts
    ref="draftComponent"
    :draft-list="Draftslist"
    :num="1"
    @fill-draft="onFillDraft"
    @refresh-draft="Drafts"
  />
</template>
<script>
import { ElSelect, ElOption } from "element-plus";
import Sortable from "sortablejs";
import Drafts from "@/components/Drafts/Drafts.vue";
const STORAGE_KEY_FORM = "SAMPLE_CLOTH_FORM_DATA";
const STORAGE_KEY_BASE64 = "SAMPLE_CLOTH_IMG_BASE64";
export default {
  name: "ProductForm",
  components: {
    ElSelect,
    ElOption,
    Drafts,
  },
  watch: {
    // 监听表单自动保存到sessionStorage
    formData: {
      handler(val) {
        sessionStorage.setItem(STORAGE_KEY_FORM, JSON.stringify(val));
      },
      deep: true,
    },
    // base64图片缓存自动保存
    imgBase64: {
      handler(val) {
        sessionStorage.setItem(STORAGE_KEY_BASE64, JSON.stringify(val));
      },
      deep: true,
    },
  },
  data() {
    return {
      Draftslist: [], //草稿箱列表
      fabricCategoryIds: [],
      listss: [],
      lists: [],
      leilist: [],
      loading: false,
      // 限制常量
      MAX_COVER_DETAIL_SIZE: 1024 * 1024, // 封面、详情 1MB
      MAX_COLOR_SIZE: 1.3 * 1024 * 1024, // 电子色卡 1.3MB
      MAX_DETAIL_COUNT: 5,
      MAX_COLOR_COUNT: 5,
      formData: {
        remark: "",
        quantify: "",
        productCode: "",
        width: "",
        weight: "",
        composition: "",
        categoryId: [],
        title: "",
        content: "",
        productpm: "",
        texts: "",
        specification: "",
        yarnCount: "",
        density: "",
        baseProductId: "",
      },
      uploadFiles: {
        "cover-1": null,
      },
      imgBase64: {},
      previewUrls: {},
      proid: "",
      sortableIns: {
        detail: null,
        color: null,
      },
      // ===== 草稿已有图片标记（商家端草稿复用，新增） =====
      draftImages: {}, // { key: { id, url, type } }，草稿后端已有的图片，发布时传 id+url 复用
    };
  },
  mounted() {
    // 从sessionStorage恢复数据
    this.restoreLocalCache();
    this.getlistss();
    this.getcp();
    this.getList().then(() => {
      this.$nextTick(() => {
        this.initSortable();
      });
    });
  },
  beforeUnmount() {
    this.clearPreviewUrls();
    // 销毁sortable实例
    Object.values(this.sortableIns).forEach((ins) => {
      if (ins) ins.destroy();
    });
  },
  methods: {
    // 本地缓存恢复
    restoreLocalCache() {
      try {
        const formStr = sessionStorage.getItem(STORAGE_KEY_FORM);
        const base64Str = sessionStorage.getItem(STORAGE_KEY_BASE64);
        if (formStr) {
          const cacheForm = JSON.parse(formStr);
          Object.keys(cacheForm).forEach((key) => {
            if (Object.prototype.hasOwnProperty.call(this.formData, key)) {
              this.formData[key] = cacheForm[key] || "";
            }
          });
        }
        if (base64Str) {
          this.imgBase64 = JSON.parse(base64Str);
        }
      } catch (e) {
        console.warn("本地缓存解析失败", e);
        this.clearLocalCache();
      }
    },
    // 清空本地sessionStorage缓存
    clearLocalCache() {
      sessionStorage.removeItem(STORAGE_KEY_FORM);
      sessionStorage.removeItem(STORAGE_KEY_BASE64);
      this.imgBase64 = {};
    },
    //获取草稿箱列表
    async Drafts() {
      const sendata = {
        currentPage: 1,
        pageSize: 50,
      };
      const res = await this.$api.Product.cgx(sendata);
      if (res.data.code == "200") {
        this.Draftslist = res.data.data.list;
        console.log(this.Draftslist, "返回的草稿箱列表是什么格式");
        //打开弹窗
        this.$refs.draftComponent.open();
      } else {
        this.$message.error("网络错误");
        this.Draftslist = [];
      }
    },
    // 初始化拖拽
    initSortable() {
      const detailEl = this.$refs.detailWrapRef;
      const colorEl = this.$refs.colorWrapRef;
      const createSort = (el, type) => {
        if (!el) return;
        this.sortableIns[type] = new Sortable(el, {
          animation: 150,
          ghostClass: "sort-ghost",
          filter: ".img-delete-btn", // 点击删除按钮不触发拖拽
          onEnd: (evt) => {
            // 获取新DOM顺序
            const itemNodes = Array.from(evt.to.querySelectorAll(".img-item"));
            const newOrderKeys = itemNodes.map((node) => node.dataset.key);
            // 重构 uploadFiles 顺序
            const newUploadFiles = {};
            newOrderKeys.forEach((key) => {
              if (this.uploadFiles[key]) {
                newUploadFiles[key] = this.uploadFiles[key];
              }
            });
            // 保留其他类型图片（cover/另外一组）
            Object.keys(this.uploadFiles).forEach((k) => {
              if (!k.startsWith(type + "-")) {
                newUploadFiles[k] = this.uploadFiles[k];
              }
            });
            this.uploadFiles = newUploadFiles;
          },
        });
      };
      createSort(detailEl, "detail");
      createSort(colorEl, "color");
    },
    //获取面料类别
    async getlistss() {
      const userid = this.$store.state.frontUserInfo.id;
      const res = await this.$api.BasicData.get(userid);
      console.log(res.data.code);
      if (res.data.code == 200) {
        this.listss = res.data.data.list;
      } else {
        this.$message.error("网络错误");
        this.listss = [];
      }
    },
    watchs(item) {
      const cpname = item;
      const itemlist = this.lists.filter((item) => item.name == cpname);
      console.log(itemlist[0], "返回的对象都包含了什么");
      if (!itemlist.length) return;
      this.formData.width = itemlist[0].width;
      this.formData.baseProductId = itemlist[0].id;
      this.formData.weight = itemlist[0].weight;
      this.formData.composition = itemlist[0].ingredients;
      this.formData.quantify = itemlist[0].quantify;
      this.formData.remark = itemlist[0].remark;
      this.formData.yarnCount = itemlist[0].yarnCount;
      this.formData.density = itemlist[0].density;
      this.formData.specification = itemlist[0].specification;
      if (itemlist[0].fabricCategoryList) {
        let text = "";
        for (
          let index = 0;
          index < itemlist[0].fabricCategoryList.length;
          index++
        ) {
          text += itemlist[0].fabricCategoryList[index].name + ",";
        }
        if (text) {
          text = text.slice(0, -1);
        }
        this.formData.texts = text;
      } else {
        this.formData.texts = "";
      }
      this.fabricCategoryIds = itemlist[0].fabricCategoryList;
    },
    //获取产品资料
    async getcp() {
      const res = await this.$api.BasicData.gets({});
      if (res.data.code == 200) {
        this.lists = res.data.data.list;
      } else {
        this.$message.error("网络错误");
        this.lists = [];
      }
    },
    async getList() {
      try {
        const sendata = {};
        const res = await this.$api.shouye.getfl(sendata);
        if (res.data.code == 200) {
          this.leilist = res.data.data.list;
        } else {
          this.$message.error("获取类别列表失败");
          this.leilist = [];
        }
      } catch (error) {
        console.error("获取类别列表异常：", error);
        this.$message.error("网络错误，获取类别列表失败");
        this.leilist = [];
      }
    },
    handleUpload(type, index) {
      // 数量校验（详情/色卡）
      if (type === "detail") {
        const count = this.getEffectiveFileCount("detail");
        if (count >= this.MAX_DETAIL_COUNT) {
          this.$message.error(`详情图最多上传${this.MAX_DETAIL_COUNT}张！`);
          return;
        }
      }
      if (type === "color") {
        const count = this.getEffectiveFileCount("color");
        if (count >= this.MAX_COLOR_COUNT) {
          this.$message.error(`电子色卡最多上传${this.MAX_COLOR_COUNT}张！`);
          return;
        }
      }
      if (index === -1) {
        this.$message.error("没有可用上传槽位");
        return;
      }
      const refName = `${type}FileInput${index}`;
      let fileInput = this.$refs[refName];
      if (Array.isArray(fileInput)) fileInput = fileInput[0];
      if (!fileInput) {
        this.$message.error("上传组件异常，请刷新页面重试");
        console.error("找不到ref", refName);
        return;
      }
      fileInput.click();
    },
    handleFileChange(type, index, e) {
      const fileList = Array.from(e.target.files);
      if (!fileList.length) return;
      // 区分不同类型图片大小校验
      let maxSize;
      let tipMsg;
      if (type === "color") {
        maxSize = this.MAX_COLOR_SIZE;
        tipMsg = "图片大小不能超过1.3MB！";
      } else {
        maxSize = this.MAX_COVER_DETAIL_SIZE;
        tipMsg = "图片大小不能超过1MB！";
      }
      // 封面仍然只能单张
      if (type === "cover") {
        const file = fileList[0];
        if (!file.type.startsWith("image/")) {
          this.$message.error("请选择图片格式的文件！");
          e.target.value = "";
          return;
        }
        if (file.size > maxSize) {
          this.$message.error(tipMsg);
          e.target.value = "";
          return;
        }
        const key = `${type}-${index}`;
        this.uploadFiles[key] = file;
        // 重新上传后，清除草稿标记（该图改为按file提交）
        delete this.draftImages[key];
        this.previewUrls[key] = URL.createObjectURL(file);
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.imgBase64[key] = reader.result;
        };
        e.target.value = "";
        return;
      }
      // ===== 详情 / 色卡 批量多选逻辑 =====
      const maxCount =
        type === "detail" ? this.MAX_DETAIL_COUNT : this.MAX_COLOR_COUNT;
      let currentCount = this.getEffectiveFileCount(type);
      const availableSlots = maxCount - currentCount;
      if (availableSlots <= 0) {
        this.$message.error(`最多只能上传${maxCount}张！`);
        e.target.value = "";
        return;
      }
      // 只取还能放的数量
      const selectFiles = fileList.slice(0, availableSlots);
      let errorCount = 0;
      for (const file of selectFiles) {
        if (!file.type.startsWith("image/")) {
          errorCount++;
          continue;
        }
        if (file.size > maxSize) {
          this.$message.error(`${file.name}：${tipMsg}`);
          errorCount++;
          continue;
        }
        // 获取下一个空位置
        const nextIdx = this.getNextUploadIndex(type);
        if (nextIdx === -1) break;
        const key = `${type}-${nextIdx}`;
        this.uploadFiles[key] = file;
        // 重新上传后，清除草稿标记（该图改为按file提交）
        delete this.draftImages[key];
        this.previewUrls[key] = URL.createObjectURL(file);
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.imgBase64[key] = reader.result;
        };
      }
      if (errorCount > 0) {
        this.$message.warning(`${errorCount}个文件跳过（非图片/大小超限）`);
      }
      if (fileList.length > availableSlots) {
        this.$message.info(`只添加${availableSlots}张，上限${maxCount}张`);
      }
      e.target.value = "";
    },
    getImagePreviewUrl(key) {
      return this.previewUrls[key] || "";
    },
    handleDeleteImage(type, index) {
      const key = `${type}-${index}`;
      // 删除本地预览
      if (this.previewUrls[key]) {
        URL.revokeObjectURL(this.previewUrls[key]);
      }
      delete this.uploadFiles[key];
      delete this.previewUrls[key];
      // 删除base64缓存
      if (this.imgBase64[key]) {
        this.imgBase64[key] = null;
      }
      // 删除草稿标记
      delete this.draftImages[key];
    },
    // 获取有效图片总数（本地File + base64缓存）用于数量判断
    getEffectiveFileCount(type) {
      let count = 0;
      // 本地文件
      Object.keys(this.uploadFiles).forEach((key) => {
        if (key.startsWith(`${type}-`) && this.uploadFiles[key]) count++;
      });
      // 仅base64缓存（草稿图或本地临时缓存都算占位，需占用槽位）
      Object.keys(this.imgBase64).forEach((key) => {
        if (
          key.startsWith(`${type}-`) &&
          this.imgBase64[key] &&
          !this.uploadFiles[key]
        )
          count++;
      });
      return count;
    },
    // 构建提交表单（发布接口）
    buildSubmitFormData(num) {
      const formData = new FormData();
      formData.append("product.flag", num);
      formData.append("product.outerKey", this.formData.productCode);
      formData.append("product.name", this.formData.productpm);
      formData.append("product.baseProductId", this.formData.baseProductId);
      if (this.proid !== "") {
        formData.append("product.id", this.proid);
      }
      if (this.formData.width)
        formData.append("product.width", this.formData.width);
      if (this.formData.quantify)
        formData.append("product.quantify", this.formData.quantify);
      if (this.formData.yarnCount)
        formData.append("product.yarnCount", this.formData.yarnCount);
      if (this.formData.density)
        formData.append("product.density", this.formData.density);
      if (this.formData.specification)
        formData.append("product.specification", this.formData.specification);
      if (this.formData.remark)
        formData.append("product.remark", this.formData.remark);
      if (this.formData.weight)
        formData.append("product.weight", this.formData.weight);
      if (this.formData.composition)
        formData.append("product.ingredients", this.formData.composition);
      if (this.formData.categoryId.length !== 0) {
        // 遍历数组，按下标逐个append
        this.formData.categoryId.forEach((item, index) => {
          formData.append(`product.categoryIds[${index}]`, item);
        });
      }
      if (this.fabricCategoryIds.length !== 0) {
        // 遍历数组，按下标逐个append
        this.fabricCategoryIds.forEach((item, index) => {
          formData.append(`product.fabricCategoryIds[${index}]`, item.id);
        });
      }
      if (this.formData.title)
        formData.append("product.title", this.formData.title);
      if (this.formData.content)
        formData.append("product.content", this.formData.content);
      // ---- 封面：新传/修改传 file，草稿未改传 id+url ----
      const coverFile = this.uploadFiles["cover-1"];
      if (coverFile) {
        formData.append("product.coverFile", coverFile, coverFile.name);
      } else if (this.draftImages["cover-1"]) {
        formData.append("product.coverId", this.draftImages["cover-1"].id);
        formData.append("product.coverUrl", this.draftImages["cover-1"].url);
      }
      // ---- 详情图：新传/修改传 file，草稿未改传 id ----
      const detailKeys = this.getAllValidImageKeys("detail");
      detailKeys.forEach((key, idx) => {
        const k = `particularsList[${idx}]`;
        if (this.uploadFiles[key]) {
          formData.append(`${k}.sort`, idx + 1);
          formData.append(
            `${k}.file`,
            this.uploadFiles[key],
            this.uploadFiles[key].name
          );
        } else if (this.draftImages[key]) {
          formData.append(`${k}.id`, this.draftImages[key].id);
          formData.append(`${k}.sort`, idx + 1);
        }
      });
      // ---- 色卡：新传/修改传 file，草稿未改传 id ----
      const colorKeys = this.getAllValidImageKeys("color");
      colorKeys.forEach((key, idx) => {
        const k = `colorcardList[${idx}]`;
        if (this.uploadFiles[key]) {
          formData.append(`${k}.sort`, idx + 1);
          formData.append(
            `${k}.file`,
            this.uploadFiles[key],
            this.uploadFiles[key].name
          );
        } else if (this.draftImages[key]) {
          formData.append(`${k}.id`, this.draftImages[key].id);
          formData.append(`${k}.sort`, idx + 1);
        }
      });
      return formData;
    },
    async handlePublish(num) {
      if (
        !this.uploadFiles["cover-1"] &&
        !this.imgBase64["cover-1"] &&
        num == 0
      ) {
        this.$message.error("封面图为必填项，请上传！");
        return;
      }
      if (!this.formData.productCode && num == 0) {
        this.$message.error("样衣编号为必填项，请填写！");
        return;
      }
      if (this.formData.categoryId.length == 0 && num == 0) {
        this.$message.error("类别为必填项，请选择！");
        return;
      }
      // 校验：存在缓存但未重新上传（且非草稿已有图片），禁止发布
      const hasNeedReUpload = this.checkNeedReUpload();
      if (hasNeedReUpload) {
        this.$message.error("图片需要重新上传后才能发布！");
        return;
      }
      this.loading = true;
      try {
        const submitFormData = this.buildSubmitFormData(num);
        const res = await this.$api.Product.save(submitFormData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (res.data.code == "200") {
          if (num == 0) {
            this.proid = "";
            this.$message.success("已上传，待审核发布");
          } else {
            this.proid = "";
            this.$message.success("存入草稿成功!");
          }
        }
        //发布成功清空本地缓存
        this.clearLocalCache();
        this.resetForm();
      } catch (error) {
        console.error("发布失败：", error);
        this.$message.error(
          `发布失败：${error.response.data.msg || "网络异常，请重试"}`
        );
      } finally {
        this.loading = false;
      }
    },
    onFillDraft(fillData, originDraftRow) {
      this.proid = fillData.proid;
      //把草稿回填表单
      Object.keys(fillData).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(this.formData, key)) {
          this.formData[key] = fillData[key];
        }
      });
      // =========新增：从原始草稿row回写面料类别 fabricCategoryIds，不改动原有fillData=========
      if (originDraftRow && originDraftRow.fabricCategoryList) {
        this.fabricCategoryIds = originDraftRow.fabricCategoryList;
        // 同步渲染formData.texts（页面上显示的面料类别tooltip文本），和watchs里面逻辑完全一致
        let text = "";
        for (
          let index = 0;
          index < originDraftRow.fabricCategoryList.length;
          index++
        ) {
          text += originDraftRow.fabricCategoryList[index].name + ",";
        }
        if (text) {
          text = text.slice(0, -1);
        }
        this.formData.texts = text;
      } else {
        this.fabricCategoryIds = [];
        this.formData.texts = "";
      }
      // ========== 图片回填逻辑【新增这一块】==========
      // 重置图片状态
      this.uploadFiles = { "cover-1": null };
      this.imgBase64 = {};
      this.previewUrls = {};
      this.draftImages = {}; // 重置草稿标记
      const fixUrl = (u) =>
        u && !/^https?:\/\//i.test(u) ? `https://${u}` : u;
      // 封面
      if (originDraftRow.coverUrl) {
        const url = fixUrl(originDraftRow.coverUrl);
        this.imgBase64["cover-1"] = url;
        this.draftImages["cover-1"] = {
          id: originDraftRow.coverId || "",
          url,
          type: "cover",
        };
      }
      // 详情图 particularsList，按sort升序
      if (
        originDraftRow.particularsList &&
        originDraftRow.particularsList.length
      ) {
        const detailList = originDraftRow.particularsList
          .slice()
          .sort((a, b) => a.sort - b.sort);
        detailList.forEach((item, idx) => {
          const key = `detail-${idx + 1}`;
          const url = fixUrl(item.url);
          this.imgBase64[key] = url;
          this.draftImages[key] = {
            id: item.id || "",
            url,
            type: "detail",
          };
        });
      }
      // 电子色卡 colorcardList，按sort升序
      if (originDraftRow.colorcardList && originDraftRow.colorcardList.length) {
        const colorList = originDraftRow.colorcardList
          .slice()
          .sort((a, b) => a.sort - b.sort);
        colorList.forEach((item, idx) => {
          const key = `color-${idx + 1}`;
          const url = fixUrl(item.url);
          this.imgBase64[key] = url;
          this.draftImages[key] = { id: item.id || "", url, type: "color" };
        });
      }
      // =============================================
      this.$message.success("草稿已加载");
      // 重建拖拽实例
      this.$nextTick(() => {
        Object.values(this.sortableIns).forEach((ins) => ins?.destroy());
        this.initSortable();
      });
    },
    resetForm() {
      this.clearPreviewUrls();
      this.formData = {
        remark: "",
        quantify: "",
        productCode: "",
        width: "",
        weight: "",
        composition: "",
        categoryId: [],
        title: "",
        content: "",
        productpm: "",
        texts: "",
        specification: "",
        yarnCount: "",
        density: "",
        baseProductId: "",
      };
      this.uploadFiles = { "cover-1": null };
      this.previewUrls = {};
      this.imgBase64 = {};
      this.draftImages = {};
    },
    clearPreviewUrls() {
      Object.keys(this.previewUrls).forEach((key) => {
        if (this.previewUrls[key]) {
          URL.revokeObjectURL(this.previewUrls[key]);
        }
      });
    },
    // 获取下一个可用槽位 1~5，复用删除释放的位置，不再无限自增
    getNextUploadIndex(type) {
      for (let i = 1; i <= 5; i++) {
        const key = `${type}-${i}`;
        if (!this.uploadFiles[key]) {
          return i;
        }
      }
      return -1;
    },
    getUploadedFiles(type) {
      const files = {};
      // 直接遍历uploadFiles，顺序已经被拖拽修改
      const sortedEntries = Object.entries(this.uploadFiles).filter(
        ([key]) => key.startsWith(`${type}-`) && this.uploadFiles[key]
      );
      sortedEntries.forEach(([key, value]) => {
        files[key] = value;
      });
      return files;
    },
    // 获取：只有Base64、没有本地File的图片
    getBase64Only(type) {
      const res = {};
      Object.keys(this.imgBase64).forEach((key) => {
        if (
          key.startsWith(`${type}-`) &&
          this.imgBase64[key] &&
          !this.uploadFiles[key]
        ) {
          res[key] = this.imgBase64[key];
        }
      });
      return res;
    },
    // 获取该类型所有有效图片key（草稿图 + 已上传File），按槽位升序
    getAllValidImageKeys(type) {
      const keys = new Set();
      Object.keys(this.uploadFiles).forEach((key) => {
        if (key.startsWith(`${type}-`) && this.uploadFiles[key]) keys.add(key);
      });
      Object.keys(this.draftImages).forEach((key) => {
        if (key.startsWith(`${type}-`) && !this.uploadFiles[key]) keys.add(key);
      });
      return Array.from(keys).sort((a, b) => {
        const idxA = Number(a.split("-")[1]);
        const idxB = Number(b.split("-")[1]);
        return idxA - idxB;
      });
    },
    // 校验是否存在需要重新上传的图片（草稿已有图片不计入）
    checkNeedReUpload() {
      // 封面
      if (
        this.imgBase64["cover-1"] &&
        !this.uploadFiles["cover-1"] &&
        !this.draftImages["cover-1"]
      )
        return true;
      // 详情、色卡（排除草稿已有图片）
      const isDraftImg = (key) => !!this.draftImages[key];
      const detailKeys = Object.keys(this.getBase64Only("detail")).filter(
        (k) => !isDraftImg(k)
      );
      const colorKeys = Object.keys(this.getBase64Only("color")).filter(
        (k) => !isDraftImg(k)
      );
      return detailKeys.length > 0 || colorKeys.length > 0;
    },
  },
};
</script>
<style lang="scss" scoped>
.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.loading-spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.publish-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  opacity: 0.8;
}
::v-deep .el-select .el-input__inner {
  background-color: #fff;
}
::v-deep .el-select .el-input__inner:focus {
  background-color: #fff;
}
.panel-title {
  color: #999;
}
.product-form-container {
  width: 100%;
  min-height: 100vh;
  padding: 20px;
  box-sizing: border-box;
  background-color: #fff !important;
  margin-bottom: -90px;
}
.form-wrapper {
  width: 90%;
  padding: 20px;
  background-color: #fff !important;
  border-radius: 4px;
  border: 1px #999 solid;
}
.form-left {
  float: left;
  width: 50%;
  margin-top: 50px;
}
.form-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  label {
    width: 74px;
    text-align: right;
    margin-right: 10px;
    font-size: 14px;
    color: #333;
    flex-shrink: 0;
  }
  input,
  ::v-deep .el-select {
    height: 32px;
    padding: 0 8px;
    border: none;
    border-bottom: 1px solid #999;
    border-radius: 4px;
    font-size: 14px;
    background-color: #fff !important;
  }
}
.single-item {
  width: 100%;
}
.fabric-group {
  margin-top: 56px;
  .group-title {
    font-size: 14px;
    color: #333;
    margin-bottom: 10px;
    font-weight: normal;
  }
}
.form-row {
  display: flex;
  .form-item {
    flex: 1;
    margin-bottom: 6px;
  }
}
.form-right {
  float: right;
  width: 45%;
  margin-left: 34px;
}
.upload-section {
  margin-bottom: 20px;
}
.upload-section h4 {
  margin-bottom: 10px;
  font-size: 14px;
  color: #333;
  font-weight: normal;
}
.upload-boxes {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}
.upload-box {
  width: 80px;
  height: 80px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #c0c4cc;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
  overflow: hidden;
  &:hover {
    border-color: #409eff;
    color: #409eff;
  }
}
.uploaded-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
/* 修复删除按钮：层级+可点击 */
.img-delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 20px;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
  border-radius: 0 4px 0 100%;
  z-index: 10;
  pointer-events: auto !important;
}
.file-input {
  display: none;
}
.textarea-section {
  clear: both;
  padding-top: 20px;
}
.textarea-item {
  margin-bottom: 15px;
}
.textarea-item label {
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
  color: #333;
}
.textarea-item textarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  resize: vertical;
  font-size: 14px;
  box-sizing: border-box;
}
.btn-group {
  margin-top: 20px;
}
.btn {
  padding: 8px 24px;
  border: none;
  border-radius: 4px;
  color: black;
  font-size: 14px;
  cursor: pointer;
  margin-right: 10px;
}
.publish-btn {
  background-color: #ff9900;
}
.save-btn {
  background-color: #666666;
}
.publish-btn:hover {
  background-color: #e68a00;
}
.save-btn:hover {
  background-color: #555555;
}
.upload-section {
  margin-bottom: 24px;
  h4 {
    margin: 0 0 12px 0;
    font-size: 14px;
    font-weight: 600;
    color: #333;
  }
}
.upload-boxes {
  display: flex;
  gap: 10px;
}
.upload-container {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
}
.upload-box {
  width: 80px;
  height: 80px;
  border: 1px dashed #dcdcdc;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;
  background: #fff;
  &:hover {
    border-color: #409eff;
    color: #409eff;
  }
  .uploaded-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 3px;
  }
  .img-delete-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: #f56c6c;
    color: #fff;
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    z-index: 10;
    opacity: 0;
    transition: opacity 0.2s;
  }
  &:hover .img-delete-btn {
    opacity: 1;
  }
}
.img-show-wrap {
  flex: 1;
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding: 2px 0;
  min-height: 80px;
  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #e5e5e5;
    border-radius: 3px;
    &:hover {
      background-color: #ccc;
    }
  }
  &::-webkit-scrollbar-track {
    background-color: #fafafa;
    border-radius: 3px;
  }
}
/*拖拽占位样式*/
.sort-ghost {
  background: #ecf5ff;
  border: 1px dashed #409eff;
}
.img-item {
  flex-shrink: 0;
  cursor: grab;
}
.img-item:active {
  cursor: grabbing;
}
.file-input {
  display: none !important;
}
.textarea-section {
  margin: 24px 0;
  .textarea-item {
    margin-bottom: 16px;
    label {
      display: block;
      margin-bottom: 8px;
      font-size: 14px;
      color: #333;
    }
    textarea {
      width: 100%;
      padding: 8px 12px;
      border: 1px solid #dcdcdc;
      border-radius: 4px;
      resize: vertical;
      font-size: 14px;
      &:focus {
        outline: none;
        border-color: #409eff;
      }
    }
  }
}
.btn-group {
  display: flex;
  gap: 12px;
  .btn {
    padding: 8px 24px;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s;
  }
  .publish-btn {
    background: #409eff;
    color: #fff;
    &:hover {
      background: #337ecc;
    }
  }
  .save-btn {
    background: #f5f7fa;
    color: #666;
    &:hover {
      background: #e5e6eb;
    }
  }
}
/* 重新上传提示文字样式 */
.reupload-tip {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 22px;
  line-height: 22px;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 10px;
  text-align: center;
  pointer-events: none;
}
</style>
